import React, { useContext, useState } from "react";
import { Button } from '@material-ui/core';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import CancelIcon from '@material-ui/icons/Cancel';
import { useRefresh, useTranslate } from 'react-admin';
import { httpClient } from 'api/httpClient'; 
import { CopyUserSettingsContext } from "contexts/CopyUserSettingsContext";
import { useNotifySuccess } from "utils/notifiers/useNotifySuccess";
import { useNotifyError } from "utils/notifiers/useNotifyError";

export const CopySettingsButton = ({ record }) => {
    const { 
        sourceUserId, setSourceUserId, 
        setIsModalOpen, setTempSourceId,
        selectedKeys, setSelectedKeys 
    } = useContext(CopyUserSettingsContext);
    
    const notifySuccess = useNotifySuccess();
    const notifyError = useNotifyError();
    const refresh = useRefresh();
    const translate = useTranslate();
    const [loading, setLoading] = useState(false);

    if (!record) return null;

    const isSource = sourceUserId === record.id;
    const hasSource = sourceUserId !== null;

    const handleCopyClick = (e) => {
        e.stopPropagation();
        setTempSourceId(record.id); 
        setIsModalOpen(true);       
    };

    const handleCancel = (e) => {
        e.stopPropagation();
        setSourceUserId(null);
        setSelectedKeys([]);
    };

    const handlePaste = async (e) => {
        e.stopPropagation();
        if (loading) return;
        setLoading(true);

        try {
            await httpClient('/copy-user-data', {
                method: 'POST', 
                body: JSON.stringify({
                    original_id: parseInt(sourceUserId, 10),
                    target_user_id: parseInt(record.id, 10),
                    keys: selectedKeys
                }),
            });
            notifySuccess(translate('osfc.dialogs.copy_user_data.success'));
            refresh();
            setSourceUserId(null);
            setSelectedKeys([]);
        } catch (error) {
            notifyError(`Error: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    if (isSource) {
        return (
            <Button color="secondary" size="small" onClick={handleCancel} startIcon={<CancelIcon />}>
                {translate('ra.action.cancel')}
            </Button>
        );
    }
    if (hasSource) {
        return (
            <Button color="primary" variant="contained" size="small" onClick={handlePaste} disabled={loading} startIcon={<AssignmentTurnedInIcon />}>
                {loading ? '...' : 'Paste'}
            </Button>
        );
    }
    return (
        <Button color="primary" size="small" onClick={handleCopyClick} startIcon={<FileCopyIcon />}>
            {translate('osfc.buttons.copy.title')}
        </Button>
    );
};